import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { encrypt } from '../../assets/utils/cryptoUtil.js';
import { reportDetail } from '@/api/module/index';
import { Toast } from "vant";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent, MarkAreaComponent, MarkLineComponent } from "echarts/components";
import VChart, { THEME_KEY } from 'vue-echarts';
import macarons from "@/assets/EChartsThemes/macarons.project.json";
use([CanvasRenderer, LineChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, MarkAreaComponent, MarkLineComponent]);
export default {
  name: "index",
  components: {
    VChart: VChart
  },
  data: function data() {
    return {
      active: 0,
      reportdata: {},
      //报告数据
      promptList: [],
      hospiatlname: window.g.VUE_APP_HOSPITALNAME,
      hospitalPhone: window.g.VUE_APP_PHONE,
      historyDataDesc: window.g.VUE_APP_HISTORY_DATA_DESC,
      reportAudit: window.g.VUE_APP_REPOT_AUDIT,
      physicalCode: '',
      //客户的体检流水号
      summary: '',
      advice: '',
      historicalData: [],
      reportImageAudit: window.g.VUE_APP_REPOT_IMAGE_AUDIT
    };
  },
  created: function created() {
    this.physicalCode = this.$route.query.physicalCode;
    this.getReportDetail();
  },
  filters: {
    valueFilter: function valueFilter(value) {
      if (value == null || value == 'null') {
        return '';
      } else {
        return value;
      }
    },
    fwFilter: function fwFilter(value) {
      if (value == null || value == '') {
        return '-';
      } else {
        return value;
      }
    }
  },
  methods: {
    //1、获取单位信息，是否允许更换套餐、项目
    //2、查询单位下的套餐列表
    getReportDetail: function getReportDetail() {
      var _this = this;

      var param = {
        physicalCode: this.physicalCode
      };
      reportDetail(param).then(function (res) {
        if (res.code == 200) {
          _this.reportdata = res.data; // 检验科 影像科

          if ((_this.reportAudit || _this.reportImageAudit) && _this.reportdata != null && _this.reportdata.ksList != null && _this.reportdata.summaryStatus != '3') {
            _this.reportdata.ksList = _this.reportdata.ksList.filter(function (item) {
              if (_this.reportAudit && _this.reportImageAudit && (item.kslx00 == '检验科' || item.kslx00 == '影像科')) {
                return item;
              } else if (_this.reportAudit && item.kslx00 == '检验科') {
                return item;
              } else if (_this.reportImageAudit && item.kslx00 == '影像科') {
                return item;
              }
            });
          }

          var summarySynchronizingT = _this.reportdata.summarySynchronizingT;

          if (summarySynchronizingT != null) {
            _this.summary = _this.reportdata.summarySynchronizingT.summary;
            _this.advice = _this.reportdata.summarySynchronizingT.advice;
          }

          res.data.historicaldata.forEach(function (item) {
            var seriesData = [];
            var historicaldataCheckdate = [];
            var historicaldataResult = [];

            if (item.resulttype != "1" && _this.historyDataDesc) {
              item.historicalDataResults = item.historicalDataResults.reverse();
            }

            item.historicalDataResults.forEach(function (rtem) {
              historicaldataCheckdate.push(rtem.checkdate);
              historicaldataResult.push(rtem.firstresult);
              var backgroundColor = '#00cc66';
              var labelColor = '#00cc66';
              var firstResult = parseFloat(rtem.firstresult);

              if (item.lowerlimit != undefined && firstResult < parseFloat(item.lowerlimit)) {
                backgroundColor = '#5ab1ef'; //设置偏低颜色

                labelColor = '#5ab1ef';
              }

              if (item.upperlimit != undefined && firstResult > parseFloat(item.upperlimit)) {
                backgroundColor = '#ff6666'; //设置偏高颜色

                labelColor = '#ff6666';
              }

              seriesData.push({
                itemStyle: {
                  color: labelColor
                },
                value: firstResult,
                label: {
                  backgroundColor: backgroundColor
                }
              });
            });

            if (_this.historyDataDesc) {
              seriesData = seriesData.reverse();
            }

            if (seriesData.length > 6) {
              var len = seriesData.length;
              var arr = seriesData.slice(0, 6);
              seriesData = arr;
            }

            if (_this.historyDataDesc) {
              historicaldataCheckdate = historicaldataCheckdate.reverse();
            }

            if (historicaldataCheckdate.length > 6) {
              var _len = historicaldataCheckdate.length;

              var _arr = historicaldataCheckdate.slice(0, 6);

              historicaldataCheckdate = _arr;
            }

            if (_this.historyDataDesc) {
              historicaldataResult = historicaldataResult.reverse();
            }

            if (historicaldataResult.length > 6) {
              var _len2 = historicaldataResult.length;

              var _arr2 = historicaldataResult.slice(0, 6);

              historicaldataResult = _arr2;
            }

            var option = {
              grid: {
                left: '60px'
              },
              title: {
                text: item.itemname,
                //主标题
                subtext: '单位 ' + item.unit //副标题

              },
              tooltip: {},
              xAxis: {
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: 'gray'
                  }
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    type: 'dashed',
                    dashOffset: 2
                  }
                },
                data: historicaldataCheckdate,
                axisLabel: {
                  rotate: historicaldataCheckdate.length > 3 ? -45 : 0
                },
                axisTick: {
                  alignWithLabel: true
                },
                boundaryGap: false //刻度与网格线对齐

              },
              yAxis: {
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: 'gray'
                  }
                },
                splitLine: {
                  show: false
                },
                axisLabel: {
                  show: false
                }
              },
              series: [{
                name: "结果",
                type: "line",
                // smooth: true,//使折线平滑曲线
                label: {
                  show: true,
                  position: 'top',
                  color: '#fff',
                  padding: [3, 5, 3, 5],
                  borderRadius: 3,
                  backgroundColor: 'inherit' // backgroundColor:'rgba(50,157,233,7)'

                },
                data: seriesData,
                markArea: {
                  //标记区域
                  itemStyle: {
                    color: 'rgba(199,242,224,.3)'
                  },
                  data: [[{
                    yAxis: item.lowerlimit == undefined ? 0 : parseFloat(item.lowerlimit)
                  }, {
                    yAxis: item.upperlimit == undefined ? 0 : parseFloat(item.upperlimit)
                  }]]
                },
                markLine: {
                  //标记上下限
                  lineStyle: {
                    color: 'rgba(199,242,224,1)',
                    width: 1,
                    type: 'dashed',
                    dashOffset: 3
                  },
                  symbol: 'none',
                  data: [{
                    name: '',
                    //下限文字
                    label: {
                      position: 'start',
                      formatter: '{b}\n{c}',
                      color: 'gray'
                    },
                    yAxis: item.lowerlimit == undefined ? 0 : item.lowerlimit
                  }, {
                    name: '',
                    //上限文字
                    label: {
                      position: 'start',
                      formatter: '{b}\n{c}',
                      color: 'gray'
                    },
                    yAxis: item.upperlimit == undefined ? 0 : item.upperlimit
                  }],
                  z: 0
                },
                z: 10
              }]
            };
            var reoptions = Object.assign(option, macarons.theme);
            var historicalData = {
              chartsOptions: reoptions,
              data: item
            };

            _this.historicalData.push(historicalData);
          });
        } else {
          Toast.fail('查询失败，请联系体检中心！');
        }
      });
    }
  }
};